const LIST_SEGMENT = 'dashboards';
const CHILDREN_SEGMENT = 'children';

/**
 * Single source of truth for the dashboards URL structure (RESTful sub-resources):
 *   /dashboards                → root list
 *   /dashboards/:id            → dashboard content
 *   /dashboards/:id/children   → nested children list
 *
 * `ROUTE_PATHS` are the route-config path strings (app.routes.ts); `DashboardsRoute` are the matching
 * Router navigation command builders (components). Keeping both here avoids scattered magic strings.
 */
export const DASHBOARDS_ROUTE_PATHS = {
  children: `${LIST_SEGMENT}/:id/${CHILDREN_SEGMENT}`,
  content: `${LIST_SEGMENT}/:id`,
  list: LIST_SEGMENT,
} as const;

/** Query-param keys used by the flat root views, search and sorting, carried in the URL. */
export const DASHBOARDS_QUERY_PARAMS = {
  search: 'search',
  sort: 'sort',
  view: 'view',
} as const;

export const DashboardsRoute = {
  children: (id: number): (string | number)[] => [`/${LIST_SEGMENT}`, id, CHILDREN_SEGMENT],
  content: (id: number): (string | number)[] => [`/${LIST_SEGMENT}`, id],
  list: (): string[] => [`/${LIST_SEGMENT}`],
} as const;
